export const COMPANY_NAME = 'My POS Company';
export const COMPANY_ADDRESS = '123 POS Street';
export const COMPANY_PHONE = '123-456-7890';
